import { ThemesEnum } from 'Constants/theme'

/**
 * useTheme hook is used to get current app theme
 */
export const useTheme = () => {
  const theme = localStorage.getItem('theme')
  const isEverphoneTheme = !theme
  const isTelekomTheme = theme === `${ThemesEnum.TELEKOM}`

  return { isEverphoneTheme, isTelekomTheme }
}
